import messages from '../../../../locale/messages';
import { inputDescLimit, inputTextLimit } from '../../../../helpers/fieldRestriction';

const validate = values => {
    const errors = {};

    if (!values.infoTitle1) {
        errors.infoTitle1 = messages.required;
    } else if (values.infoTitle1.trim() == "") {
        errors.infoTitle1 = messages.required;
    } else if (values.infoTitle1.length < 2 ) {
        errors.infoTitle1 = messages.required
    } else if (values.infoTitle1.length > inputTextLimit) {
        errors.infoTitle1 = messages.inputTextLimitError
    }

    if (!values.infoTitle2) {
        errors.infoTitle2 = messages.required;
    } else if (values.infoTitle2.trim() == "") {
        errors.infoTitle2 = messages.required;
    } else if (values.infoTitle2.length < 2 ) {
        errors.infoTitle2 = messages.required
    } else if (values.infoTitle2.length > inputTextLimit) {
        errors.infoTitle2 = messages.inputTextLimitError
    }

    if (!values.infoTitle3) {
        errors.infoTitle3 = messages.required;
    } else if (values.infoTitle3.trim() == "") {
        errors.infoTitle3 = messages.required;
    } else if (values.infoTitle3.length < 2 ) {
        errors.infoTitle3 = messages.required
    } else if (values.infoTitle3.length > inputTextLimit) {
        errors.infoTitle3 = messages.inputTextLimitError
    }

    if (!values.infoTitle4) {
        errors.infoTitle4 = messages.required;
    } else if (values.infoTitle4.trim() == "") {
        errors.infoTitle4 = messages.required;
    } else if (values.infoTitle4.length < 2 ) {
        errors.infoTitle4 = messages.required
    } else if (values.infoTitle4.length > inputTextLimit) {
        errors.infoTitle4 = messages.inputTextLimitError
    }

    if (!values.infoContent4) {
        errors.infoContent4 = messages.required;
    } else if (values.infoContent4.trim() == "") {
        errors.infoContent4 = messages.required;
    } else if (values.infoContent4.length < 2 ) {
        errors.infoContent4 = messages.required
    } else if (values.infoContent4.length > inputDescLimit) {
        errors.infoContent4 = messages.inputDescLimitError;
    }





    return errors;
};

export default validate;